import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  percentOff: {
    defaultMessage: '{percent} off',
    description: 'Compact discount marker on a shipment tier showing savings percentage',
    id: '9y0Xxj',
  },
});
